module.exports = __webpack_public_path__ + "img/20251204.3d47c41b.jpg";